import { useQuery } from "@tanstack/react-query";

async function fetchIpAddress() {
    const response = await fetch("https://api64.ipify.org?format=json");
    const data = await response.json();
    return data.ip;
}

export const useIpAddress = () => {
    return useQuery<string>({
        queryKey: ["ipAddress"],
        queryFn: () => fetchIpAddress(),
        staleTime: 1000 * 60 * 60 * 4, // 4 hours
    });
};
